import { Label, Stack, TextField } from '@fluentui/react';
import * as React from 'react';
import { isGetHelpSourceApp } from '../../../../../web/utils/statelessUtil';
import { RequestConstants, SourceApps } from '../../../../models/constants/constants';
import { FreelanceRequest } from '../../models/requestModels';
import {
  IRequestDetailsStyles,
  getTextFieldStyles,
  getGetHelpTextFieldStyles,
} from '../../styles/requestDetailsStyles';
import { IStyledComponent } from '../../styles/themesUI';
import { getString } from '../../../../../web/utils/stringLoader';

interface ITitleFieldComponentProps {
  isTitleFieldDisabled: boolean;
  isDarkTheme: boolean;
  sourceApp: SourceApps;
  title: string;
  isTitleValid: boolean;

  // dispatchers
  dispatchUpdateRequest: (properties: Partial<FreelanceRequest>) => void;
  dispatchUpdateIsTitleValid: (isTitleValid: boolean) => void;
}

type IThemedTitleFieldProps = ITitleFieldComponentProps & IStyledComponent<IRequestDetailsStyles>;

export class TitleField extends React.PureComponent<IThemedTitleFieldProps> {
  public render(): React.ReactNode {
    const textFieldStyles = getTextFieldStyles({ theme: this.props.theme, isInputValid: this.props.isTitleValid });
    const maxCharacterCount = RequestConstants.TitleTextFieldCharLimit;

    this.props.dispatchUpdateIsTitleValid(this.props.isTitleFieldDisabled ? true : false);
    if (isGetHelpSourceApp(this.props.sourceApp)) {
      return (
        <Stack horizontal>
          <Label required={true}>
            {getString('requestCreation_titleLabel')}
          </Label>
          <TextField
            id="userTitleInput"
            type="text"
            onChange={this.onTitleInputChange}
            styles={getGetHelpTextFieldStyles(this.props.theme)}
            maxLength={maxCharacterCount}
            underlined
          />
        </Stack>
      );
    }

    return (
      <TextField
        label={getString('requestCreation_titleLabel')}
        styles={textFieldStyles} id='userTitleInput'
        maxLength={maxCharacterCount}
        type='text'
        value={this.props.title}
        onChange={this.onTitleInputChange}
        disabled={this.props.isTitleFieldDisabled}
        required
        errorMessage={!this.props.isTitleValid && getString('requestCreation_invalidTitleMessageText')}
      />
    );
  }

  private onTitleInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!!event && !!event.target) {
      event.stopPropagation();
      this.props.dispatchUpdateRequest({
        Title: event.target.value,
      });
    }
    this.props.dispatchUpdateIsTitleValid(!!event.target.value.trim());
  };
}
